import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  width: "100%",
  backgroundColor: theme.palette.bgPage,
  minHeight: "60vh",
}));

export const Hero = styled("div")(({ theme }) => ({
  width: "100%",
  background: `linear-gradient(135deg, ${theme.palette.searchBg} 0%, ${theme.palette.searchBgMid} 50%, ${theme.palette.searchBgLight} 100%)`,
  padding: "60px 20px",
  textAlign: "center",
  position: "relative",
  overflow: "hidden",

  "&::before": {
    content: '"✈"',
    position: "absolute",
    fontSize: "280px",
    opacity: 0.04,
    top: "-40px",
    right: "-20px",
    color: "#ffffff",
    transform: "rotate(-20deg)",
    pointerEvents: "none",
    userSelect: "none",
  },
}));

export const HeroTitle = styled("h1")(({ theme }) => ({
  fontSize: 38,
  fontWeight: 700,
  color: theme.palette.textWhite,
  margin: "0 0 12px",
  letterSpacing: "-0.5px",

  [theme.down("sm")]: {
    fontSize: 28,
  },
}));

export const HeroSubtitle = styled("p")(({ theme }) => ({
  fontSize: 16,
  color: theme.palette.whiteAlpha80,
  margin: 0,
  maxWidth: 520,
  marginLeft: "auto",
  marginRight: "auto",
  lineHeight: 1.6,

  [theme.down("sm")]: {
    fontSize: 14,
  },
}));

export const HeroBadge = styled("span")(({ theme }) => ({
  display: "inline-block",
  backgroundColor: theme.palette.primary,
  color: theme.palette.textWhite,
  fontSize: 13,
  fontWeight: 600,
  padding: "4px 14px",
  borderRadius: 20,
  marginBottom: 16,
  letterSpacing: "0.3px",
}));

export const Content = styled("div")(({ theme }) => ({
  maxWidth: 1500,
  margin: "0 auto",
  padding: "40px 20px 60px",

  [theme.down("xl")]: {
    maxWidth: 1200,
  },

  [theme.down("lg")]: {
    maxWidth: 1000,
  },

  [theme.down("md")]: {
    maxWidth: 800,
  },

  [theme.down("xs")]: {
    padding: "24px 16px 40px",
  },
}));

export const SectionTitle = styled("h2")(({ theme }) => ({
  fontSize: 20,
  fontWeight: 600,
  color: theme.palette.textSecondary,
  margin: "0 0 24px",
  display: "flex",
  alignItems: "center",
  gap: 10,

  "&::after": {
    content: '""',
    flex: 1,
    height: 1,
    backgroundColor: theme.palette.borderLight,
    display: "block",
  },
}));

export const List = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(5, 1fr)",
  gap: 16,

  [theme.down("xl")]: {
    gridTemplateColumns: "repeat(4, 1fr)",
  },

  [theme.down("lg")]: {
    gridTemplateColumns: "repeat(3, 1fr)",
  },

  [theme.down("md")]: {
    gridTemplateColumns: "repeat(2, 1fr)",
  },

  [theme.down("xs")]: {
    gridTemplateColumns: "repeat(1, 1fr)",
    gap: 10,
  },

  a: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "14px 16px",
    backgroundColor: theme.palette.white,
    border: `1px solid ${theme.palette.borderLight}`,
    borderRadius: 12,
    textDecoration: "none",
    color: theme.palette.textPrimary,
    fontSize: 14,
    fontWeight: 500,
    boxShadow: `0 1px 4px ${theme.palette.shadowSm}`,
    transition: "all 0.2s ease",
    position: "relative",
    overflow: "hidden",

    "&::before": {
      content: '"✈"',
      fontSize: 15,
      color: theme.palette.primary,
      flexShrink: 0,
      lineHeight: 1,
    },

    "&::after": {
      content: '"→"',
      marginLeft: "auto",
      fontSize: 16,
      color: theme.palette.textLight,
      transition: "transform 0.2s ease, color 0.2s ease",
      flexShrink: 0,
    },

    "&:hover": {
      borderColor: theme.palette.primaryBorder,
      boxShadow: `0 6px 20px ${theme.palette.primaryShadowHover}`,
      backgroundColor: theme.palette.primarySubtle,
      color: theme.palette.primaryDark,
      transform: "translateY(-2px)",

      "&::after": {
        transform: "translateX(4px)",
        color: theme.palette.primary,
      },
    },

    "&:active": {
      transform: "translateY(0)",
    },
  },
}));
